import { COUPONS_ROUTES } from '../../constants/_routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_coupon_request = () => {
  return {
    type: couponsTypes.create.request
  }
}

const create_coupon_success = (response) => {
  return {
    type: couponsTypes.create.success,
    payload: response.data.coupon
  }
}

const create_coupon_failure = (messages) => {
  return {
    type: couponsTypes.create.failure,
    payload: messages
  }
}

const create_coupon = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_coupon_request())

    // Request
    axios.post(
      COUPONS_ROUTES.create,
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "A new coupon has been created")
      dispatch( create_coupon_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating coupon."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_coupon_failure(errors))
    })
  }

}

export {
  create_coupon
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/create.js